import React from 'react';
import './Illustrations.css';

const TAIL_PATH = 'M160 248 Q236 252 236 190 Q236 156 220 144 Q208 136 209 152 Q210 180 198 200 Q186 222 160 226 Z';
const KEY_COLUMNS = [113, 125, 137];
const KEY_ROWS = [208, 218, 228];

/**
 * Revetall's fox ("rev") with glasses, holding a calculator: the "økonomisjef" you don't have time to be.
 * @returns {JSX.Element} Decorative drawing
 */
function FoxFigure() {
  return (
    <svg className="illustration" viewBox="0 0 260 280" aria-hidden="true" focusable="false">
      <ellipse className="ill-shadow" cx="130" cy="264" rx="60" ry="8" />

      {/* Floating math symbols */}
      <path className="ill-symbol ill-symbol-navy" d="M30 72 L50 72" />
      <path className="ill-symbol ill-symbol-orange" d="M222 38 L222 58 M212 48 L232 48" />
      <path className="ill-symbol ill-symbol-gold" d="M26 128 L44 128 M26 138 L44 138" />

      {/* Bushy tail with a fluffy white tip, behind the body */}
      <defs>
        <clipPath id="fox-tail-clip">
          <path d={TAIL_PATH} />
        </clipPath>
      </defs>
      <path className="ill-fox" d={TAIL_PATH} />
      <path
        className="ill-white"
        clipPath="url(#fox-tail-clip)"
        d="M196 120 L262 120 L262 178 Q246 184 232 176 Q220 182 204 168 Z"
      />

      {/* Body, belly and darker feet */}
      <path className="ill-fox" d="M94 172 Q86 252 130 256 Q174 252 166 172 Q158 146 130 146 Q102 146 94 172 Z" />
      <ellipse className="ill-white" cx="130" cy="212" rx="24" ry="32" />
      <ellipse className="ill-fox-dark" cx="114" cy="254" rx="13" ry="7" />
      <ellipse className="ill-fox-dark" cx="146" cy="254" rx="13" ry="7" />

      {/* Ears: orange, white inside, dark tips */}
      <path className="ill-fox" d="M84 88 L86 36 Q88 26 96 32 L124 64 Z" />
      <path className="ill-fox" d="M176 88 L174 36 Q172 26 164 32 L136 64 Z" />
      <path className="ill-white" d="M92 80 L92 46 L114 68 Z" />
      <path className="ill-white" d="M168 80 L168 46 L146 68 Z" />
      <path className="ill-navy" d="M86 45 L86 36 Q88 26 96 32 L107 45 Z" />
      <path className="ill-navy" d="M174 45 L174 36 Q172 26 164 32 L153 45 Z" />

      {/* Head with the classic white fox mask */}
      <path className="ill-fox" d="M78 104 Q78 62 130 60 Q182 62 182 104 Q182 134 154 150 Q130 164 106 150 Q78 134 78 104 Z" />
      <path
        className="ill-white"
        d="M80 110 Q98 104 114 118 Q124 128 130 128 Q136 128 146 118 Q162 104 180 110 Q180 134 154 150 Q130 164 106 150 Q80 134 80 110 Z"
      />

      {/* Face: glasses, eyes, blush, nose, mouth */}
      <circle className="ill-navy" cx="110" cy="100" r="4.5" />
      <circle className="ill-navy" cx="150" cy="100" r="4.5" />
      <circle className="ill-white" cx="108.5" cy="98.5" r="1.6" />
      <circle className="ill-white" cx="148.5" cy="98.5" r="1.6" />
      <circle className="ill-line-navy" cx="110" cy="100" r="13" />
      <circle className="ill-line-navy" cx="150" cy="100" r="13" />
      <path className="ill-line-navy" d="M123 100 Q130 96 137 100" />
      <ellipse className="ill-cheek" cx="97" cy="131" rx="7" ry="4" />
      <ellipse className="ill-cheek" cx="163" cy="131" rx="7" ry="4" />
      <path className="ill-navy" d="M123 130 Q130 126 137 130 Q134 138 130 139 Q126 138 123 130 Z" />
      <path className="ill-line-navy" d="M124 144 Q130 149 130 142 Q130 149 136 144" />

      {/* Arms reaching round to the calculator */}
      <path className="ill-fox-limb" d="M100 176 Q88 200 107 205" />
      <path className="ill-fox-limb" d="M160 176 Q172 200 153 205" />

      {/* Calculator with a tick on the screen */}
      <rect className="ill-navy" x="106" y="182" width="48" height="60" rx="8" />
      <rect className="ill-screen" x="112" y="188" width="36" height="14" rx="4" />
      <path className="ill-line-navy" d="M122 195 L126 199 L134 191" />
      {KEY_ROWS.map((y, rowIndex) =>
        KEY_COLUMNS.map((x, columnIndex) => {
          const isEqualsKey = rowIndex === KEY_ROWS.length - 1 && columnIndex === KEY_COLUMNS.length - 1;
          return (
            <rect
              key={`${x}-${y}`}
              className={isEqualsKey ? 'ill-orange' : 'ill-white'}
              x={x}
              y={y}
              width="10"
              height="7"
              rx="2"
            />
          );
        })
      )}

      {/* Paws gripping the calculator's sides */}
      <circle className="ill-fox-dark" cx="107" cy="205" r="7.5" />
      <circle className="ill-fox-dark" cx="153" cy="205" r="7.5" />
    </svg>
  );
}

export default FoxFigure;
